import React from "react"

export default function Save2() {
   return (
      <svg fill="none" viewBox="0 0 19 19" height="19" width="19" xmlns="http://www.w3.org/2000/svg">
         <g clipPath="url(#clip0_1318_5656)">
            <path d="M13.4447 2.83605C13.1597 2.55105 12.7772 2.39355 12.3797 2.39355H4.0022C3.1697 2.39355 2.5022 3.06855 2.5022 3.89355V14.3936C2.5022 15.2186 3.1772 15.8936 4.0022 15.8936H14.5022C15.3272 15.8936 16.0022 15.2186 16.0022 14.3936V6.01605C16.0022 5.61855 15.8447 5.23605 15.5597 4.95855L13.4447 2.83605ZM9.2522 14.3936C8.0072 14.3936 7.0022 13.3886 7.0022 12.1436C7.0022 10.8986 8.0072 9.89355 9.2522 9.89355C10.4972 9.89355 11.5022 10.8986 11.5022 12.1436C11.5022 13.3886 10.4972 14.3936 9.2522 14.3936ZM10.0022 6.89355H5.5022C4.6772 6.89355 4.0022 6.21855 4.0022 5.39355C4.0022 4.56855 4.6772 3.89355 5.5022 3.89355H10.0022C10.8272 3.89355 11.5022 4.56855 11.5022 5.39355C11.5022 6.21855 10.8272 6.89355 10.0022 6.89355Z" fill="#5B5E71" />
         </g>
         <defs>
            <clipPath id="clip0_1318_5656">
               <rect width="18" height="18" fill="white" transform="translate(0.252197 0.143555)" />
            </clipPath>
         </defs>
      </svg>
   )
}